export const toAbsoluteUrl = (siteOrigin: string, path: string): string => {
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    const origin = siteOrigin.endsWith('/') ? siteOrigin.slice(0, -1) : siteOrigin;
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return `${origin}${normalizedPath}`;
};
